import { render, staticRenderFns } from "./ExtraMonetization.vue?vue&type=template&id=fbfcb506&scoped=true"
import script from "./ExtraMonetization.vue?vue&type=script&lang=js"
export * from "./ExtraMonetization.vue?vue&type=script&lang=js"
import style0 from "./ExtraMonetization.vue?vue&type=style&index=0&id=fbfcb506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfcb506",
  null
  
)

export default component.exports